import React, {useState} from "react";

import {Box, Typography} from "@material-ui/core";
import FfairTooltip from "view/components/Layout/Tooltip";
import useClasses from "./styles";

type ContractorChipProps = {
  companyName: string;
  helperLeftPosition?: boolean;
};

export default function ContractorChip({
  companyName,
  helperLeftPosition,
}: ContractorChipProps) {
  const [isContinueShown, setIsContinueShown] = useState(false);
  const classes = useClasses();
  const text = `Contractor, ${companyName}`;
  return (
    <Box style={{position: "relative"}}>
      <Box
        onMouseEnter={() => setIsContinueShown(true)}
        onMouseLeave={() => setIsContinueShown(false)}
      >
        <FfairTooltip title={text}>
          <Typography className={classes.exhibitorContractorField}>
            {text}
          </Typography>
        </FfairTooltip>
      </Box>
    </Box>
  );
}

ContractorChip.defaultProps = {helperLeftPosition: false};
